import { useTranslation } from "react-i18next";
import { aiStateTypes, stateIconDone, stateIconError, stateIconSend, stateIconUnavailable, stateIconWaiting } from "../../../types/ai/states";

interface StatePreviewProps {
    containerClass?: string;
    state: aiStateTypes;
}

export const StatePreview = ({
    containerClass = 'row mx-0 text-center',
    state
}:StatePreviewProps) => {
    const { t } = useTranslation('generation');
    return(
        <div className={containerClass}>
            { state
                ? state === 'send'
                    ? <p className='h4'>{stateIconSend} {t('state.sending')}</p>
                    : state === 'waiting'
                        ? <p className='h4'><span className="spin">{stateIconWaiting}</span> {t('state.waiting')}</p>
                        : state === 'error'
                            ? <p className='h4'>{stateIconError} {t('state.error')}</p>
                            : state === 'done'
                                ? <p className='h4'>{stateIconDone} {t('state.done')}</p>
                                : state === 'unavailable'
                                    ? <p className='h4 text-secondary'>{stateIconUnavailable} {t('state.unavailable')}</p>
                                    : <></>
                : <></>
            }
        </div>
    )
};